<template>
  <div class="home contenido">
    <div class="container">
        <HelloWorld 
            msg="Auditoría en seguros"
            idea="Un programa que examina la actualidad de tus planes, su vigencia vs riesgos actuales, para descubrir si tu organización está debidamente protegida."
            :imagen="imagen"
         />
         <Titulo titulo="¿Cómo lo hacemos?" />
         <div class="espacio mt-5"></div>
         <Fototextosombra titulo="Ponemos al día tu tranquilidad" texto="La mayoría de las organizaciones que cuentan con programas de protección de su patrimonio fueron implementados hace 5 o 10 años, tiempo en el que año tras año se renuevan sin detenerse a revisar su actualidad. ¿Qué certeza tiene tu empresa en caso de un siniestro con las condiciones al día de hoy de tu póliza?" :imagen="imagen2" pos="fotoderecha" />
         <Fototextosombra titulo="Generando certeza" texto="Nuestra auditoría se aplica bajo una metodología avalada por estándares e institutos internacionales buscando maximizar el rendimiento financiero en toda la organización." :imagen="imagen4" pos="fotoizquierda" />
         <Fototextosombra titulo="Lo hacemos así:" texto="<ul>
         <li class='mb-3'>Analizamos que se tiene contratado actualmente.</li>
         <li class='mb-3'>Escuchamos tus prioridades en costos, necesidades, alcances.</li>
         <li class='mb-3'>Reestructuramos una nueva propuesta 100% viable, actualizada y con base en tus requerimientos.</li>
         </ul>" :imagen="imagen3" pos="fotoderecha" />
         <Titulo2 titulo="¿Está actualizada tu empresa?" />
    </div>
    <div class="triangulo"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-header-new_03-auditoria-en-seguros.jpg'
import Imagen2 from '@/assets/images/pageinteriors_03auditoria-en-seguros-01.jpg'
import Imagen3 from '@/assets/images/pageinteriors_03auditoria-en-seguros-03.jpg'
import Imagen4 from '@/assets/images/pageinteriors_03auditoria-en-seguros-02.jpg'
import Titulo from '@/components/Titulo.vue'
import Titulo2 from '@/components/Titulo2.vue'
import Fototextosombra from '@/components/Fototextosombra.vue'
export default {
  name: 'Nosotros',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
          imagen4: Imagen4,
      }
  },
  components: {
    HelloWorld,
    Titulo,
    Titulo2,
    Fototextosombra,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', true);
  }
}
</script>
<style>
.container-fluid {
    /*background-size: cover;
    background: url(../assets/images/background-pattern01-short.png);*/
}
.rojo {
    color: red;
}
</style>
<style scoped>
.blanco {
    background: #FFF;
}
.contenido {
    min-height: 500px;
}
.gris {
    background: #F2F2F2;
    border-bottom: 8px solid #000;
    margin-top: 180px !important;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 50px, 0% 0%, 100% 0%);
    background: #FFF;
    margin-top: 0;
    position: absolute;
    z-index: 100;
}
h3 {
    font-size: 26px;
    font-weight: 700;
}
.texto {

}
.crm-titulo {
    font-weight: 700;
    font-size: 14px;
}
.crm-subtitulo {
    font-weight: 700;
    font-size: 18px;
}
.img-crm {
    width: 125px;
}
@media only screen and (max-width: 1199px){
    .crm-titulo {
        font-weight: 700;
        font-size: 14px;
    }
    .crm-subtitulo {
        font-weight: 700;
        font-size: 17px;
    }
    .img-crm {
    }
    .triangulo {
        height: 50px;
    }
}
</style>
